import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

// Masifi: sección unificada de settings propias ("Masifi Inbox"), admin-only.
// Net-new (rebase-safe). Su registro en settings.routes.js + Sidebar.vue = touchpoints.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/masifi'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'masifi_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
